import { useTimerStore } from "../../timer/timer-store";

export function useTimer() {
  const {
    requestId,
    isRunning,
    start,
    pause,
    resume,
    stop,
    reset,
    getElapsedMs,
  } = useTimerStore();

  return {
    requestId,
    isRunning,
    isActive: requestId !== null,
    start,
    pause,
    resume,
    stop,
    reset,
    getElapsedMs,
    /** Current elapsed time in whole minutes (rounded). */
    get elapsedMinutes(): number {
      return Math.round(getElapsedMs() / 60_000);
    },
  };
}
